// Removes the sessionId from the sessionStorage
export const removeSessionId = () => {
  return window.sessionStorage.removeItem("sessionId");
};
